import React from 'react';

interface FloatingLabelProps {
    children: React.ReactNode;
    className?: string;
}

const FloatingLabel: React.FC<FloatingLabelProps> = ({ children, className }) => (
    <div className={`${className}`}>
        <label className={`floating-label`}>
            {children}
        </label>
    </div>
);

export default FloatingLabel;